import React, { useRef } from 'react';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';
import { useSmoothScroll } from 'src/hooks/useSmoothScroll';
import ExternalTemplate from 'src/templates/ExternalTemplate';
import * as S from './AuthLayout.styles';
const AuthLayout = ({
  heading,
  subHeading,
  children,
  error,
  success,
  warning,
  extra
}) => {
  const ref = useRef(null);
  const {
    t
  } = useTranslation();
  useSmoothScroll(error ? ref : null, ref.current?.offsetTop);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("title", null, t('b2c.login.page.title')), /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: t('b2c.login.page.descrition')
  })), /*#__PURE__*/React.createElement(ExternalTemplate, null, /*#__PURE__*/React.createElement(S.Container, null, /*#__PURE__*/React.createElement(S.Content, null, /*#__PURE__*/React.createElement(S.Heading, null, heading), /*#__PURE__*/React.createElement(S.SubHeading, null, subHeading), /*#__PURE__*/React.createElement(S.FormContainer, {
    ref: ref
  }, extra, error && /*#__PURE__*/React.createElement(S.Alert, {
    severity: "error"
  }, error), warning && /*#__PURE__*/React.createElement(S.Alert, {
    severity: "warning"
  }, warning), success && /*#__PURE__*/React.createElement(S.Alert, {
    severity: "success"
  }, success), children)))));
};
export default AuthLayout;